(ns quuppa.qsm.users.events
  (:require [re-frame.core :as rf]))

(rf/reg-event-db
  :qsm/qsm-users
  (fn [db [_ params]]
    (assoc-in db [:qsm :qsm-users] params)))

(rf/reg-event-fx
  :qsm/change-user-role
  (fn [_ [_ user-id role-name]]
    {:fx [[:server-dispatch {:event [:qsm/change-user-role [user-id role-name]]
                             :on-success [:qsm/remove-admin-sidebar]
                             :on-error [:notifications/notify]}]]}))

(rf/reg-event-fx
  :qsm/change-user-resource-role
  (fn [_ [_ data]]
    {:fx [[:server-dispatch {:event [:qsm/change-user-resource-role data]
                             :on-success [:qsm/remove-admin-sidebar]
                             :on-error [:notifications/notify]}]]}))

(rf/reg-event-fx
  :qsm/load-users-and-roles
  (fn [{db :db} _]
    {:db (assoc-in db [:qsm :qsm-users] :loading)
     :fx [[:server-dispatch [:qsm/load-users-and-roles]]]}))

(rf/reg-event-fx
  ::users-view-stop
  (fn [{db :db} _]
    ;; meaningless optimization, but clear users from db as they are rarely accessed
    {:db (update db :qsm dissoc :qsm-users :resource-users)}))

(rf/reg-event-fx
  :qsm/delete-user
  (fn [_ [_ user-id]]
    {:fx [[:server-dispatch [:qsm/delete-user {:id user-id}]]]}))

(rf/reg-event-fx
  :qsm/remove-resource-role
  (fn [_ [_ data]]
    {:fx [[:server-dispatch [:qsm/remove-resource-role data]]]}))

(rf/reg-event-db
  :qsm/admin-sidebar
  (fn [db [_ v]]
    (assoc-in db [:qsm :ui :admin-sidebar] v)))

(rf/reg-event-db
  :qsm/add-user-form-data
  (fn [db [_ value-keyword v]]
    (assoc-in db [:qsm :ui :admin-sidebar :add-user-form-data value-keyword] v)))

(rf/reg-event-db
  :qsm/edit-user-form-data
  (fn [db [_ value-keyword v]]
    (assoc-in db [:qsm :ui :admin-sidebar :edit-user-form-data value-keyword] v)))

(rf/reg-event-db
  :qsm/assign-user-form-data
  (fn [db [_ value-keyword v]]
    (assoc-in db [:qsm :ui :admin-sidebar :assign-user-form-data value-keyword] v)))

(rf/reg-event-db
  :qsm/init-assign-user-form-data
  (fn [db [_ v]]
    (assoc-in db [:qsm :ui :admin-sidebar :assign-user-form-data] v)))

(rf/reg-event-db
  :qsm/init-edit-user-form-data
  (fn [db [_ v]]
    (assoc-in db [:qsm :ui :admin-sidebar :edit-user-form-data] v)))

(rf/reg-event-db
  :qsm/remove-user-form-data
  (fn [db _]
    (update-in db [:qsm :ui :admin-sidebar] dissoc
               :add-user-form-data
               :edit-user-form-data
               :assign-user-form-data)))

(rf/reg-event-db
  :qsm/remove-admin-sidebar
  (fn [db _]
    (-> db
        (update-in [:qsm :ui] dissoc :admin-sidebar)
        (update-in [:qsm :ui] dissoc :add-user-in-progress?)
        (update-in [:qsm :ui] dissoc :assign-user-in-progress?))))

(rf/reg-event-fx
  :qsm/event-failed
  (fn [{:keys [db]} [_ event-name value]]
    {:db (assoc-in db [:qsm :ui :admin-sidebar event-name] value)}))


(rf/reg-event-db
  :qsm/resource-users
  (fn [db [_ params]]
    (assoc-in db [:qsm :resource-users] params)))

(rf/reg-event-fx
  :qsm/add-user
  (fn [{db :db} [_ form-data]]
    {:db (assoc-in db [:qsm :ui :add-user-in-progress?] true)
     :fx [[:server-dispatch {:event [:qsm/add-user form-data]
                             :on-success [:qsm/remove-admin-sidebar]
                             :on-error [:qsm/event-failed :qsm/add-user]}]]}))

(rf/reg-event-fx
  :qsm/add-user-and-resource-role
  (fn [{db :db} [_ add-user-data on-success-handler resource-role-data]]
    {:db (assoc-in db [:qsm :ui :assign-user-in-progress?] true)
     :fx [[:server-dispatch {:event [:qsm/add-user add-user-data]
                             :on-success [on-success-handler resource-role-data]
                             :on-error [:qsm/event-failed :qsm/add-user]}]]}))

(rf/reg-event-fx
  :qsm/get-resource-users
  (fn [_ [_ params]]
    {:fx [[:server-dispatch {:event [:qsm/get-resource-users params]
                             :on-success [:qsm/resource-users]
                             :on-error [:qsm/event-failed :qsm/resource-users]}]]}))

(rf/reg-event-fx
  :qsm/assign-user-to-site
  (fn [{db :db} [_ form-data]]
    {:db (assoc-in db [:qsm :ui :assign-user-in-progress?] true)
     :fx [[:server-dispatch {:event [:qsm/assign-user-to-site form-data]
                             :on-success [:qsm/remove-admin-sidebar]
                             :on-error [:qsm/event-failed :qsm/assign-user-to-site]}]]}))

(rf/reg-event-fx
  :qsm/assign-user-to-project
  (fn [{db :db} [_ form-data]]
    {:db (assoc-in db [:qsm :ui :assign-user-in-progress?] true)
     :fx [[:server-dispatch {:event [:qsm/assign-user-to-project form-data]
                             :on-success [:qsm/remove-admin-sidebar]
                             :on-error [:qsm/event-failed :qsm/assign-user-to-project]}]]}))
